import { Input } from '@builder.io/sdk';

import { moleculeHeadingFields } from 'molecules/Heading/config';
import sectionFields from 'molecules/Section/config';

import noIconCardFields from 'organisms/Cards/NoIconCard/config';

const simpleCardDeckFields = [
  ...moleculeHeadingFields,
  {
    name: 'cards',
    type: 'list',
    subFields: noIconCardFields,
    helperText: 'Add up to 7 cards. Each card contains text-only content without icons.',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      if (options.get('cards').length > 7) {
        options.set('cards', options.get('cards').slice(0, 7));
        alert('Maximum card count is 7. Removing excess cards.');
      }
    },
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const simpleCardDeckConfig = {
  name: 'SimpleCardDeck',
  inputs: simpleCardDeckFields,
};

export type SimpleCardDeckConfig = GenerateBuilder<typeof simpleCardDeckFields>;
export default simpleCardDeckConfig;
